module.exports = __webpack_public_path__ + "img/12.7c7e1dd4.png";